export default __webpack_public_path__ + "static/media/Padres.53019ee9.png";